import {
    collection,
    component,
    CustomObjectContextData,
    dateField,
    EntityData,
    field,
    identifier,
    reloadable,
    unrestricted
} from "@fedeltapointofsale/data-client";
import {AddressData} from "../../address/address.data";
import {PreparationResourceTypeReferenceData} from "../../order-processing/preparation-resource-type/preparation-resource-type.data";

export class SalePeriodData extends EntityData<SalePeriodData> {
    @identifier id: number;
    @field name: string;
    @field code: string;
    @dateField startTime: Date;
}

export class OutletSalePeriodData extends EntityData<OutletSalePeriodData> {
    @identifier id: number;
    @component salePeriod: SalePeriodData;
    @field disabled: boolean = false;
    @dateField startTime: Date;
}

export class OutletReferenceData extends EntityData<OutletReferenceData> {
    @identifier outletId: number;
    @field name: string;
}

export class OutletExternalNameType {
    public static readonly WEB_TERMINAL_STORE_NAME: string = "WEB TERMINAL STORE NAME";
    public static readonly OUTLET_STORE_NAME: string = "OUTLET STORE NAME";
    public static readonly LOCATION_NAME: string = "LOCATION NAME";
    public static readonly COMPANY_NAME: string = "COMPANY NAME";
}

export class OutletCompanyDetailsData extends EntityData<OutletCompanyDetailsData> {
    @identifier companyDetailsId: number;
    @field companyName: string;
    @field telephone: string;
    @field email: string;
    @component address: AddressData;
}

export class OutletData extends EntityData<OutletData> {
    @identifier outletId: number;
    @field name: string;
    @field storeName: string;
    @field smsNameType: string = OutletExternalNameType.OUTLET_STORE_NAME;
    @field exportCode: string;
    @field billableCode: string;
    @field description: string;
    @field outletGroupId: number;
    @field companyDetailsId: number;
    @reloadable @component companyDetails: OutletCompanyDetailsData;
    @field useCompanyAddressForPickup: boolean;
    @field pickupTelephone: string;
    @component pickupAddress: AddressData;
    @field useCompanyAddressForDelivery: boolean;
    @field deliveryTelephone: string;
    @component deliveryAddress: AddressData;
    @field latitude: number;
    @field longitude: number;
    @field timeZone: string;
    @field allowStockOrder: boolean = true;
    @component customObjectContext: CustomObjectContextData;
    @component ordersPreparationResourceType: PreparationResourceTypeReferenceData;
    @unrestricted @collection(OutletSalePeriodData) outletSalePeriods: OutletSalePeriodData[];
}
